import React from 'react';
import './App.css';

function App() {
  return (
    <div className="App">
      <header className='header'>
        <h1>FI/10</h1>
        <h3>Earn Your Financial Independence Within 10 Years</h3>
      </header>
      <section className='container'>
        <br/>
        <p>
          Project FI/10 is a small, tight-knit group of ambitious, relatively young
          individuals from various backgrounds, united by their curiosity, drive, and
          shared goal of achieving Financial Independence (FI) within a maximum of 10
          years in India. Together, we work on ideas and experiments to discover a
          startup that can fast-track our journey to FI. These experiments help us
          learn how to create successful business models capable of generating
          recurring profits with minimal effort.
        </p>
        <br/>
        <h2>Guidelines:</h2>
        <ul>
          <li>
            Each “experiment” will be lead by one person - who has proposed the idea. They would be the team lead and product manager for the project. They would make all the final decisions, and the success of the project will rely heavily on their decision making.
          </li>
          <li>
            If the original Team Lead does not want to take the responsibility, they can request another person to do so, and take up a different role.
          </li>
          <li>
            The idea and execution should be built in a way to generate passive income i.e. you make money even when you are sleeping. Processes should be automated, the product should sell itself. The marketing should be organic and take a life of it’s own (PMF). And we shouldn’t require more people than necessary to reach our targets.
          </li>
          <li>
            Each member in the team is expected to work on the project only part time. Members can start committing full time, if the project is starting to generate profits and we have built sufficient runway for at least 6-12 months for one person to commit full time.
          </li>
          <li>
            The project should be run as a practical “Research Study” following the Scientific Method. We come up with a hypothesis (idea), we figure out how to test the idea (generate passive recurring profits) and we come to a conclusion of the success or failure of the idea, document our learnings, and pivot towards another hypothesis if we have failed.
          </li>
          <li>
            Each experiment has to be designed with proper constraints and criteria to limit loss and to measure the success or failure regularly. If it’s not on the path of success, we should come together and figure out what is wrong, and pivot the project to get back on track to targeted milestones.
          </li>
          <li>
            Each experiment should ideally be designed to operate as close to zero budget as possible, at least until it starts generating real money. If some cost is unavoidable, then the team can explore financing options - individual contributions, crowd funding, angel investors, VCs, startup accelerators etc.
          </li>
          <li>
            There will be no equity associated to the project, unless it starts generating at least $1,000 USD (profits) per month for each member of the team. We will not discuss any equity until then, however you can share your expectations for equity privately with the team lead / PM for the current project. They will be the CEO and will register the “startup” - turning the project into a real business.
          </li>
          <li>
            The project and experiments will run under the company Coderplex Technologies Pvt Ltd, and if they become a startup, they should be registered as a Subsidiary Company, with the PM controlling the equity distribution fully.
          </li>
          <li>
            There is no promise or commitment that all the members of the team will continue to stick with the team until the experiment is successful (turn it into a real startup). Team members might drop out, or the PM might decide that they are not helpful for the current project. This doesn't stop members from starting or joining other projects.
          </li>
        </ul>
        <h3>FI Target: Between ₹5 - ₹10 Crore within 10 years</h3>
        <p>
          The actual net worth necessary to have FI in India can vary between individuals, depending on their circumstances, lifestyle choices, etc and also on factors like inflation, economic growth etc.. The goal for us is to reach FI not to stop working, but to be able to leave the corporate world for good, and work on passion projects, even if they do not pay well. We target FI to earn our full independence. We can choose to continue working at a job, or become a teacher, or volunteer, or build a startup etc. 

          Based on my calculations, targeting between 5 Cr - 10 Cr within 10 years is a good range to reach FI in India, to earn the independence to do whatever else you want. It is a good baseline. This can be more than enough for many people as well. However, keep in mind that, to be able to have FI, you would need to invest this money, to earn and live off of the returns. 
        </p>

        <h3>How do we reach FI?</h3>
        <p>
          <strong>Option 1 :</strong> Sell the product, at minimum price required to provide each member with min Rs 5 Cr - 10 Cr return relative to their equity. Meaning, someone with even just 5% equity in the registered startup should be able to exit with min Rs 5 - 10 Cr from the deal. 
        </p>
        <p>
          <strong>Option 2 :</strong> Generate steady growing recurring profits per month, pay high salary to each team member for at least 10 years for them to reach Rs 5 Cr - 10 Cr net worth (in savings). This option depends also on them working part time or full time somewhere else. The income from the project should ideally be an additional source of income that they can then invest and compound over time as well, rather than the primary source of income and used for expenses. 
        </p>
        <h3>Resources:</h3>
        <p>
          <a
            href="https://fiindia.gitbook.io/wiki/"
            target="_blank"
            rel="noopener noreferrer"
          >
            FIRE India Guidebook
          </a>
        </p>

        {/* <div className="buttons">
          <a
            href="https://your-form-url.com"
            target="_blank"
            rel="noopener noreferrer"
            className="btn"
          >
            Fill Out Form
          </a>
          <a
            href="https://discord.gg/your-invite-link"
            target="_blank"
            rel="noopener noreferrer"
            className="btn"
          >
            Join Discord
          </a>
        </div> */}
      </section>
      
    </div>
  );
}

export default App;
